import { useCallback, useEffect, useState } from "react";
import { loadGtag } from "../../lib/gtag";
import { loadClarity } from "../../lib/clarity";
import { loadMetaPixel, trackMetaPageView } from "../../lib/meta-pixel";
import {
  ACCEPTED,
  CONSENT_CHANGED_EVENT,
  REJECTED,
  clearTrackingCookies,
  getConsent,
  setConsent,
  trackingActive,
} from "../../lib/consent";

// A hozzajarulas megadasakor minden mero egyszerre indul.
// Tobbszor is meghivodhat (az accept() kozvetlenul, es a setConsent altal
// kivaltott esemenyre az evaluate() is), ezert idempotensnek kell lennie:
// a betoltok sajat "loaded" flaggel vedettek, az egyszeri PageView-t pedig
// ez a flag vedi.
let initialPageViewSent = false;

function enableTracking() {
  loadGtag();
  loadClarity();
  loadMetaPixel();

  // A gtag "config" es a Clarity magatol rogzit egy oldalmegtekintest, a Meta
  // viszont nem: a Pixel initje szandekosan nem kuld PageView-t (SPA), ezert
  // az aktualis nezetet itt jelentjuk be. A tovabbi route-valtasokat mar az
  // AnalyticsTracker kezeli.
  if (initialPageViewSent) return;
  initialPageViewSent = true;
  trackMetaPageView();
}

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  const evaluate = useCallback(() => {
    const saved = getConsent();

    if (saved === ACCEPTED) {
      enableTracking();
      setShow(false);
      return;
    }

    if (saved === REJECTED) {
      // Itt a legbiztosabb törölni: ezen az oldalbetöltésen semmilyen mérési
      // script nem fut, így nem tudja visszaírni a sütijeit.
      clearTrackingCookies();
      setShow(false);
      return;
    }

    // nincs döntés -> kérdezzünk
    setShow(true);
  }, []);

  useEffect(() => {
    evaluate();
    window.addEventListener(CONSENT_CHANGED_EVENT, evaluate);
    return () => window.removeEventListener(CONSENT_CHANGED_EVENT, evaluate);
  }, [evaluate]);

  const accept = () => {
    setConsent(ACCEPTED);
    enableTracking();
    setShow(false);
  };

  const reject = () => {
    const wasLoaded = trackingActive();
    setConsent(REJECTED);
    setShow(false);

    // A már betöltött mérési scriptek futás közben nem távolíthatók el, ezért
    // korábbi elfogadás visszavonásakor újratöltjük az oldalt. A sütiket NEM
    // itt töröljük: a még futó scriptek az újratöltésig visszaírnák őket –
    // az evaluate() a friss betöltésen takarít.
    if (wasLoaded) {
      window.location.reload();
      return;
    }

    clearTrackingCookies();
  };

  if (!show) return null;

  return (
    <div
      className="alert bg-purple alert-dismissible fade show fixed-bottom mb-0 rounded-0"
      role="alert"
      style={{
        background: '#472c6b'
      }}
    >
      <div className="d-flex flex-column flex-md-row gap-2 justify-content-between align-items-center">
        <span className="text-white">
          Az oldal a működéséhez szükséges sütiket, valamint – az Ön
          hozzájárulása esetén – forgalommérő és a használatot rögzítő
          (Google Analytics, Microsoft Clarity), valamint hirdetési (Meta Pixel)
          sütiket használ. Részletek az{" "}
          <a className="text-white" style={{textDecoration: 'underline'}} href="/adatvedelem">
            Adatvédelmi Szabályzatban
          </a>
          .
        </span>
        <div className="ms-3 flex ">
          <button onClick={reject} className="btn btn-outline-secondary btn-sm me-2">
            Elutasítás
          </button>
          <button onClick={accept} className="btn-half site-button small">
            Mindent elfogadok
          </button>
        </div>
      </div>
    </div>
  );
}
